import $ from 'jquery'

class Example {
	//? 1. describe and create/initiate our object

	constructor() {
		//Verables

		this.events()
		this.URL = window.location.href
		// order
		this.order = this.getUrlParameter('orderby')
		// cat
		this.cat = this.getUrlParameter('cat')
		// post_to_show
		this.post_to_show = this.getUrlParameter('posts_to_show')
	}

	//?events
	events() {
		let myObj = this

		// on load
		$(window).on('load', () => {
			// if Posts to show is not null or undefined
			if (
				myObj.getUrlParameter('posts_to_show') != null ||
				myObj.getUrlParameter('posts_to_show') != undefined
			) {
				// set post_to_show select
				$('.post_to_shows').val(myObj.post_to_show)
			}

			// if order is not null or undefined
			if (
				myObj.getUrlParameter('orderby') != null ||
				myObj.getUrlParameter('orderby') != undefined
			) {
				// set order select
				$('#shop_order_filter').val(myObj.order)
			}
		})

		$('#shop_order_filter').on('change', function () {
			console.log(myObj.getUrlParameter('cat'))

			// update orders
			myObj.order = $(this).val()
			myObj.prepData()
			console.log(myObj.order)
		})

		$('.post_to_shows').on('change', function () {
			// update post_to_show
			myObj.post_to_show = $(this).val()
			myObj.prepData()
		})
	}

	//? 3. methods (functions)
	// prep data for url
	prepData() {
		// get url
		let url = window.location.href
		let endOfURL = '?'
		// remove anything after the ?
		url = url.split('?')[0]

		// if genAvailableOrders not null or undefined
		if (
			this.genAvailableOrders() != null ||
			this.genAvailableOrders() != undefined
		) {
			// add to url
			endOfURL += '&' + this.genAvailableOrders()
		}

		// if post_to_show not null or undefined
		if (this.post_to_show != null || this.post_to_show != undefined) {
			// add to url
			endOfURL += '&posts_to_show=' + this.post_to_show
		}

		// combine url and endOfURL
		this.URL = url + endOfURL

		console.log(this.URL)
		// go to url

		location.href = this.URL
	}

	genAvailableOrders() {
		// options
		// title
		// title-desc
		// price
		// price-desc

		// get current order
		let currentOrder = this.order
		// set string
		let string = ''
		// if current order is titleASC
		if (currentOrder == 'title') {
			// set string
			string = 'orderby=title'
		}
		// if current order is titleDESC
		if (currentOrder == 'title-desc') {
			// set string
			string = 'orderby=title-desc'
		}
		// if current order is priceASC
		if (currentOrder == 'price') {
			// set string
			string = 'orderby=price'
		}
		// if current order is priceDESC
		if (currentOrder == 'price-desc') {
			// set string
			string = 'orderby=price-desc'
		}
		// return string
		return string
	}

	getUrlParameter(sParam) {
		// get url
		var sPageURL = window.location.search.substring(1),
			// split url
			sURLVariables = sPageURL.split('&'),
			// set
			sParameterName,
			i

		// loop through url
		for (i = 0; i < sURLVariables.length; i++) {
			// split url
			sParameterName = sURLVariables[i].split('=')

			// if url is equal to sParam
			if (sParameterName[0] === sParam) {
				// return sParameterName
				return sParameterName[1] === undefined
					? true
					: decodeURIComponent(sParameterName[1])
			}
		}
	}
}

export default Example
